import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Topbar from './components/menu/Topbar';
import TopbarMenuItems from './components/menu/TopbarMenuItems';
import { Button } from 'reactstrap';
import SidebarMenu from './components/menu/SidebarMenu';
import SidebarMenuCollapsed from './components/menu/SidebarMenuCollapsed';
import { ImmutableLoadingBar as LoadingBar } from 'react-redux-loading-bar'
import { ToastContainer } from 'react-toastify';
import Transition from 'react-transition-group/Transition';
import { Redirect } from 'react-router-dom';
import SidebarWithTopbar from './components/menu/SidebarWithTopbar';
import SidebarWithTopbarDef from './components/menu/SidebarWithTopBarDef';
import config from './config';
import { rest } from 'lodash';
import { getLanguageTranslations } from './actions/company';
import CollapsedWithSidebar from './components/menu/CollapsedWithSidebar';
import CollapsedWithSidebarGroupIcon from './components/menu/CollapsedWithSidebarGroupIcon';
import Chatbot from './Chatbot';

const fadeInAndOut = ({ children, position, ...props }) => (
    <Transition
        {...props}
        timeout={800}
        onEnter={node => node.classList.add('fadeIn', 'animated')}
        onExit={node => {
            node.classList.remove('fadeIn', 'animated');
            node.classList.add('fadeOut', 'animated');
        }}>
        {children}
    </Transition>
);

class Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSideMenuActive: false,
            isExpanded: true,
             isDarkTheme: false 
        }
    }
    toggleSideMenu = () => {
        this.setState({ isSideMenuActive: !this.state.isSideMenuActive });
    }
    setActiveMenu() {
        //TODO: Set Menu Highlights
    }
    toggleIsExpanded = (key) => {
        if (key) {
            this.setState({ isExpanded: false });
        }
        this.setState({ isExpanded: !this.state.isExpanded });
    }

    hideSidebar = () => {
        this.setState({ isExpanded: false });
    }
    componentDidMount() {
        const { getCompanyDetails, fetchNavWorkflows, fetchNavWorkflowsPublic, setActiveLanguage, setLanguages, getLanguageTranslations
            , getCustomIcons, user, addTranslationForLanguage, getAllReports } = this.props;
        getCompanyDetails && getCompanyDetails();
        getAllReports && getAllReports();
        getCustomIcons && getCustomIcons();
        fetchNavWorkflows && fetchNavWorkflows(user);
        fetchNavWorkflowsPublic && fetchNavWorkflowsPublic(user);
        getLanguageTranslations().then(resp => {
            const languages = resp.data && resp.data.data ? resp.data.data : [];
            const langKey = Object.keys(languages)
            setLanguages(langKey);
            for (const [key, value] of Object.entries(languages)) {
                addTranslationForLanguage(value, `${key}`);
                for (const [key1, value1] of Object.entries(value)) {
                    addTranslationForLanguage(value, `${key}`);

                }
            }
            setActiveLanguage('en')
        });
    }
    hideSidebar = () => {
        this.setState({ isExpanded: false });
    }
    collapsewithsidebartoggleIsExpanded = (key) => {

        this.setState({ isExpanded: true });
    }
    collapsewithsidebartoggleIsExpandedFalse = (key) => {

        this.setState({ isExpanded: false });
    }

    componentWillReceiveProps(nextProps) {
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        document.title = nextProps.companyDetails && nextProps.companyDetails.data ? nextProps.companyDetails.data.defaultWindowTitle : 'Powered by Apto.ai';
        if (nextProps.companyDetails.data && nextProps.companyDetails.data.favIcoUrl) {
            link.href = config.assetsBasePath + nextProps.companyDetails.data.favIcoUrl;
        }
    }

  applyTheme = (isDark) => {
  const companyName = window.location.hostname.substring(
    0,
    window.location.hostname.indexOf('.')
  );

    const newHref = 'https://instagram.business.codeninja.ai/api/player/l/public/instagram' +  (isDark ? '_dark.css' : '.css');


//   const newHref =
//     window.location.origin +
//     '/api/player/l/public/' +
//     companyName +
//     (isDark ? '_dark.css' : '.css');

  // 🔥 existing css link find karo
  const links = document.querySelectorAll('link[rel="stylesheet"]');

  let themeLink = null;

  links.forEach(link => {
    if (link.href.includes('/api/player/l/public/')) {
      themeLink = link;
    }
  });

  if (themeLink) {
    themeLink.href = newHref; // ✅ REPLACE
  }
};  



toggleTheme = () => {
  const isDarkTheme = !this.state.isDarkTheme;

  this.setState({ isDarkTheme });
  this.applyTheme(isDarkTheme);

  localStorage.setItem('theme', isDarkTheme ? 'dark' : 'light');
};

    render() {
        const { user, isDasboard, companyDetails, getCompanyDetails, getCustomIcons,allReports } = this.props;
        if (this.context.router.route.location.search && this.context.router.route.location.search.indexOf('hideMenu=true') > -1) {
            return <div className='h-100'>
                <div id='player-container' className='container-fluid p-0'>
                    {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                </div>
              
                <LoadingBar className="loading-bar" />
                <ToastContainer
                    position="bottom-right"
                    toastClassName={"toaster"}
                    type="default"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    transition={fadeInAndOut}
                />

            </div>
        }
        if (user.isAnonymous && this.context.router.route.location.pathname === "/login") {
            return <Redirect to={this.context.router.route.location.pathname} />
        }

        const menuType = companyDetails && companyDetails.data && window.innerWidth > 480 &&
            (user && user.user && user.user.email ? companyDetails.data.menuType : companyDetails.data.publicMenuType);

            const isDarkThemeEnabled =
  companyDetails &&
  companyDetails.data &&
  companyDetails.data.companySettings &&
  companyDetails.data.companySettings.isDarkThemeEnabled;

        const enableIconGroup = companyDetails && companyDetails.data && companyDetails.data.companySettings &&
            (user && user.user && user.user.email ? companyDetails.data.companySettings.enableIconGroup : false);
        const fixedSideBar = companyDetails && companyDetails.data && companyDetails.data.companySettings &&
            (user && user.user && user.user.email ? companyDetails.data.companySettings.fixedSideBar : false);
        const topBarEnabled = companyDetails && companyDetails.data && companyDetails.data.companySettings &&
            (user && user.user && user.user.email ? companyDetails.data.companySettings.topBarEnabled : false);
        const disableRightClick = this.props.companyDetails && this.props.companyDetails.data && this.props.companyDetails.data.companySettings && this.props.companyDetails.data.companySettings.disableRightClick ? this.props.companyDetails.data.companySettings.disableRightClick : null;
       const reportBasedChatbot = this.props.companyDetails && this.props.companyDetails.data && this.props.companyDetails.data.companySettings && this.props.companyDetails.data.companySettings.reportBasedChatbot ? this.props.companyDetails.data.companySettings.reportBasedChatbot : null;
        if (menuType === 'SIDEBARWITHTOPBAR' && !fixedSideBar) {
            return <div className='h-100'>
                <SidebarWithTopbar
                    currentLanguage={this.props.currentLanguage}
                    user={user}
                    translate={this.props.translate}
                    isPublic={!(user && user.user && user.user.email)}
                    logout={() => {
                        const { router: { history } } = this.context;
                        this.props.logout(history, companyDetails)
                    }}
                    getCompanyDetails={getCompanyDetails}
                    getCustomIcons={getCustomIcons}
                    baseWorkflowRoute="/app"
                    companyDetails={companyDetails}
                    toggleIsExpanded={this.toggleIsExpanded}
                    isExpanded={this.state.isExpanded}
                />
                <div id='player-container-sidebarWithTopbar' onClick={this.hideSidebar} className='container-fluid p-0'>
                    {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                </div>
                <LoadingBar className="loading-bar" />
                <ToastContainer
                    position="bottom-right"
                    toastClassName={"toaster"}
                    type="default"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    transition={fadeInAndOut}
                />
            </div>
        }
        if (menuType === 'SIDEBARWITHTOPBAR' && fixedSideBar) {
            return <div className='h-100'>
               
                <SidebarWithTopbar
                    currentLanguage={this.props.currentLanguage}
                    user={user}
                    translate={this.props.translate}

                    blic={!(user && user.user && user.user.email)}
                    logout={() => {
                        const { router: { history } } = this.context;
                        this.props.logout(history, companyDetails)
                    }}
                    getCompanyDetails={getCompanyDetails}
                    getCustomIcons={getCustomIcons}
                    baseWorkflowRoute="/app"
                    companyDetails={companyDetails}
                    toggleIsExpanded={this.toggleIsExpanded}
                    isExpanded={this.state.isExpanded}
                />
                <div id='player-container-sidebarWithTopbar' onClick={this.hideSidebar} className='container-fluid p-0'>
                    {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                </div>
                <LoadingBar className="loading-bar" />
                <ToastContainer
                    position="bottom-right"
                    toastClassName={"toaster"}
                    type="default"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    transition={fadeInAndOut}
                />
            </div>
        }

        if (menuType === 'COLLAPSEDWITHSIDEBAR' && !enableIconGroup) {
            return <div className='h-100'>
                <CollapsedWithSidebar
                    currentLanguage={this.props.currentLanguage}
                    user={user}
                    translate={this.props.translate}
                    isPublic={!(user && user.user && user.user.email)}
                    logout={() => {
                        const { router: { history } } = this.context;
                        this.props.logout(history, companyDetails)
                    }}
                    getCompanyDetails={getCompanyDetails}
                    getCustomIcons={getCustomIcons}
                    baseWorkflowRoute="/app"
                    companyDetails={companyDetails}
                    toggleIsExpanded={this.toggleIsExpanded}
                    collapsewithsidebartoggleIsExpanded={this.collapsewithsidebartoggleIsExpanded}
                    collapsewithsidebartoggleIsExpandedFalse={this.collapsewithsidebartoggleIsExpandedFalse}
                    isExpanded={this.state.isExpanded}
                />
                <div id={`player-container-sidebarWithTopbar collapse_wi_side ${this.state.isExpanded && window.storeExpand && 'active_expand_sideConent'}`} onClick={this.hideSidebar} className='container-fluid p-0'>
                    {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                </div>
                <LoadingBar className="loading-bar" />
                <ToastContainer
                    position="bottom-right"
                    type="default"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    transition={fadeInAndOut}
                />
            </div>
        }
        if (menuType === 'COLLAPSEDWITHSIDEBAR' && enableIconGroup) {
            return <div className='h-100'>
                <CollapsedWithSidebarGroupIcon
                    currentLanguage={this.props.currentLanguage}
                    user={user}
                    translate={this.props.translate}
                    isPublic={!(user && user.user && user.user.email)}
                    logout={() => {
                        const { router: { history } } = this.context;
                        this.props.logout(history, companyDetails)
                    }}
                    getCompanyDetails={getCompanyDetails}
                    getCustomIcons={getCustomIcons}
                    baseWorkflowRoute="/app"
                    companyDetails={companyDetails}
                    toggleIsExpanded={this.toggleIsExpanded}
                    collapsewithsidebartoggleIsExpanded={this.collapsewithsidebartoggleIsExpanded}
                    collapsewithsidebartoggleIsExpandedFalse={this.collapsewithsidebartoggleIsExpandedFalse}
                    isExpanded={this.state.isExpanded}
                />
                {
                    console.log("ppppppppppp_-------->", this.state.isExpanded, window.storeExpand)
                }
                <div id={`player-container-sidebarWithTopbar collapse_wi_side ${this.state.isExpanded && window.storeExpand && 'active_expand_sideConent'}`} onClick={this.hideSidebar} className='container-fluid p-0'>
                    {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                </div>
                <LoadingBar className="loading-bar" />
                <ToastContainer
                    position="bottom-right"
                    type="default"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    transition={fadeInAndOut}
                />
            </div>
        }

        if (menuType === 'COLLAPSED') {
            return <div className="h-100 sidebar-workflow-nav"
                onContextMenu={(e) => {
                    disableRightClick && e.preventDefault();
                }}

            >
                <SidebarMenuCollapsed
                    currentLanguage={this.props.currentLanguage}
                    translate={this.props.translate}
                    isPublic={!(user && user.user && user.user.email)}
                    logout={() => {
                        const { router: { history } } = this.context;
                        this.props.logout(history, companyDetails)
                    }}
                    baseWorkflowRoute="/app"
                    user={user}
                    getCompanyDetails={getCompanyDetails}
                    companyDetails={companyDetails}
                    isDasboard={isDasboard}
                    router={this.context.router}
                    setActiveLanguage={this.props.setActiveLanguage}
                    availableLanguages={this.props.availableLanguages}
                     toggleTheme={this.toggleTheme}
                    isDarkTheme={this.state.isDarkTheme}
                     isDarkThemeEnabled={isDarkThemeEnabled} 

                    setActiveMenu={this.setActiveMenu.bind(this)

                    }
                // {...rest}
                >
                    <div id='player-container' className='container-fluid p-0'>
                        {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                    </div>
                    <LoadingBar className="loading-bar" />
                    <ToastContainer
                        position="bottom-right"
                        toastClassName={"toaster"}
                        type="default"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        pauseOnHover
                        transition={fadeInAndOut}
                    />
                </SidebarMenuCollapsed>
            </div>
        }
        else if (menuType == "SIDEBAR" && topBarEnabled) {
            return <div className="h-100 sidebar-workflow-nav"
                onContextMenu={(e) => {
                    disableRightClick && e.preventDefault();
                }}

            >
                <SidebarWithTopbarDef
                    currentLanguage={this.props.currentLanguage}
                    translate={this.props.translate}
                    isPublic={!(user && user.user && user.user.email)}
                    logout={() => {
                        const { router: { history } } = this.context;
                        this.props.logout(history, companyDetails)
                    }}
                    baseWorkflowRoute="/app"
                    user={user}
                    getCompanyDetails={getCompanyDetails}
                    companyDetails={companyDetails}
                    isDasboard={isDasboard}
                    router={this.context.router}
                    topBarEnabled={topBarEnabled}
                     toggleTheme={this.toggleTheme}
                    isDarkTheme={this.state.isDarkTheme}
                      isDarkThemeEnabled={isDarkThemeEnabled} 
                    setActiveMenu={this.setActiveMenu.bind(this)
                        
                    }>
                    <div id='player-container-sidebarWithTopbarDef' className='container-fluid p-0' >
                        {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                    </div>
                    <LoadingBar className="loading-bar" />
                    <ToastContainer
                        position="bottom-right"
                        toastClassName={"toaster"}
                        type="default"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        pauseOnHover
                        transition={fadeInAndOut}
                    />
                </SidebarWithTopbarDef>
            </div>
        }
        else if (menuType == "SIDEBAR" && !topBarEnabled) {
            return <div className="h-100 sidebar-workflow-nav"
                onContextMenu={(e) => {
                    disableRightClick && e.preventDefault();
                }}

            >
                <SidebarMenu
                    currentLanguage={this.props.currentLanguage}
                    translate={this.props.translate}
                    isPublic={!(user && user.user && user.user.email)}
                    logout={() => {
                        const { router: { history } } = this.context;
                        this.props.logout(history, companyDetails)
                    }}
                    baseWorkflowRoute="/app"
                    user={user}
                    getCompanyDetails={getCompanyDetails}
                    companyDetails={companyDetails}
                    isDasboard={isDasboard}
                    router={this.context.router}
                    availableLanguages={this.props.availableLanguages}
                    setActiveLanguage={this.props.setActiveLanguage}
                    topBarEnabled={topBarEnabled}
                    setActiveMenu={this.setActiveMenu.bind(this)   }
                      toggleTheme={this.toggleTheme}
                    isDarkTheme={this.state.isDarkTheme}
                      isDarkThemeEnabled={isDarkThemeEnabled} 
                    
                    >
                    <div id='player-container' className='container-fluid p-0'>
                        {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                    </div>
                    <LoadingBar className="loading-bar" />
                    <ToastContainer
                        position="bottom-right"
                        toastClassName={"toaster"}
                        type="default"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        pauseOnHover
                        transition={fadeInAndOut}
                    />
                </SidebarMenu>
            </div>
        }
        return (
            <div className='h-100'>
                <TopbarMenuItems
                    currentLanguage={this.props.currentLanguage}
                    user={user}
                    translate={this.props.translate}
                    isPublic={!(user && user.user && user.user.email)}
                    logout={() => {
                        const { router: { history } } = this.context;
                        this.props.logout(history, companyDetails)
                    }}
                    getCompanyDetails={getCompanyDetails}
                    getCustomIcons={getCustomIcons}
                    baseWorkflowRoute="/app"
                    companyDetails={companyDetails}
                     toggleTheme={this.toggleTheme}
                    isDarkTheme={this.state.isDarkTheme}
                      isDarkThemeEnabled={isDarkThemeEnabled} 
                />
                <div id='player-container' className='container-fluid p-0'>
                    {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                </div>
                <LoadingBar className="loading-bar" />
                <ToastContainer
                    position="bottom-right"
                    toastClassName={"toaster"}
                    type="default"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    transition={fadeInAndOut}
                />
                {/* <SidebarMenu isDasboard={isDasboard} router={this.context.router} translate={ this.props.translate } setActiveMenu={this.setActiveMenu.bind(this)}>
                <div id='player-container' className='container-fluid p-0'>
                    {this.props.children}    <Chatbot reportBasedChatbot={reportBasedChatbot} {...this.props}/>
                </div>
                <LoadingBar className="loading-bar" />
                <ToastContainer
                    position="bottom-right"
                    type="default"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                    transition={fadeInAndOut}
                />
                </SidebarMenu> */}
            </div>
        );
    }
}

Layout.propTypes = {
    logout: PropTypes.func,
    user: PropTypes.object,
    isDasboard: PropTypes.bool
};

Layout.defaultProps = {
    isDasboard: false
}

Layout.contextTypes = {
    router: PropTypes.object
}

export default Layout;